import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import { onlinePriceApi } from '@/lib/api/online-price-api'
import { formatApiError } from '@/lib/format-api-error'
import { m } from '@/lib/paraglide/messages'

export const onlinePriceKeys = {
    all: ['online-prices'] as const,
}

export function useOnlinePrices() {
    return useQuery({
        queryKey: onlinePriceKeys.all,
        queryFn: () => onlinePriceApi.list(),
    })
}

export function useSetOnlinePrice() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: ({
            productId,
            price,
        }: {
            productId: string
            price: number
        }) => onlinePriceApi.set(productId, price),
        onSuccess: () => {
            toast.success(m.online_price_saved())
            void qc.invalidateQueries({ queryKey: onlinePriceKeys.all })
        },
        onError: (err: unknown) => {
            const { title, description } = formatApiError(
                err,
                m.online_price_save_failed(),
            )
            toast.error(title, { description })
        },
    })
}

export function useClearOnlinePrice() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: (productId: string) => onlinePriceApi.clear(productId),
        onSuccess: () => {
            toast.success(m.online_price_cleared())
            void qc.invalidateQueries({ queryKey: onlinePriceKeys.all })
        },
        onError: (err: unknown) => {
            const { title, description } = formatApiError(
                err,
                m.online_price_clear_failed(),
            )
            toast.error(title, { description })
        },
    })
}
